export const basicSort = (a, b) => {
    if(a === undefined){
      return 1;
    }
    if(b === undefined){
      return -1;
    }
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  }
